<div [ngClass]="getItemClass()">
  <div [ngClass]="{'errors-tablet': this.isTablet, 'errors-mobile': this.isMobile, 'errors': this.isDesktop}" *ngIf="errorMessage">
    <span class="error-icon" [ngClass]="{'mobile' : this.isTablet || this.isMobile}">
      <fa-icon [icon]="errorIcon"></fa-icon>
    </span>{{ errorMessage }}
  </div>

  <div class="container-fluid">
    <div class="row g-0">

      <div class="icon-details d-flex col-auto justify-content-center align-items-center" [ngClass]="getStyleClass()">
        <div class="text-center w-100">
          <span>
            <fa-icon [icon]="completed ? checkIcon : circleIcon" size="2x"></fa-icon>
          </span>
        </div>
      </div>

      <div class="title-details d-flex col justify-content-start align-items-center ps-2" [ngClass]="getStyleClass()">
        <div *ngIf="!payoutId" class="w-100"><b>{{ title }}</b></div>
        <div *ngIf="payoutId" class="w-100 alt-link" [GA]="{event: {category: 'Select Final Payout Status', action: 'Click', label: 'Item Detail'}}" (click)="openPayout(payoutId)"><b>{{ title }}</b></div>
      </div>

      <div class="data-details d-flex col-auto justify-content-end align-items-center" [ngClass]="getStyleClass()">
        <div class="text-end">
          <div *ngIf="completed">{{ date | date: 'shortDate' }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
